module.exports = __webpack_public_path__ + "img/wfzc.d86f4a4.png";